import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "Dialog",
  icon: "💬",
  templates: [
    {
      title: "Podcast-Interview-Vorlage",
      content: `Schreiben Sie ein Interview im Podcast-Stil zwischen zwei Sprechern.
- Sprecher 1 ist der Moderator: [ein neugieriger und begeisterter Tech-Journalist].
- Sprecher 2 ist der Gast: [ein renommierter KI-Forscher, der gerade eine bahnbrechende Studie veröffentlicht hat].
- Das Diskussionsthema ist [die Zukunft der Zusammenarbeit zwischen Mensch und KI in kreativen Bereichen].
- Der Ton sollte [gesprächig, aufschlussreich und gelegentlich humorvoll] sein.
- Fügen Sie einen natürlichen Austausch mit Nachfragen und Anekdoten ein.

Formatieren Sie jede Zeile als "Speaker 1:" oder "Speaker 2:" gefolgt von ihrem Dialog.`,
      mode: 'multi'
    },
    {
      title: "Debatte-Vorlage",
      content: `Schreiben Sie eine strukturierte Debatte zwischen zwei Sprechern mit gegensätzlichen Standpunkten.
- Sprecher 1 argumentiert [für Remote-Arbeit als dauerhaften Standard].
- Sprecher 2 argumentiert [dass Zusammenarbeit im Büro für Innovation unerlässlich ist].
- Beide Sprecher sollten [gut begründete Argumente mit realen Beispielen] präsentieren.
- Der Ton sollte [respektvoll, aber leidenschaftlich] sein.
- Jeder Sprecher sollte direkt auf die Punkte des anderen eingehen.

Formatieren Sie jede Zeile als "Speaker 1:" oder "Speaker 2:" gefolgt von ihrem Dialog.`,
      mode: 'multi'
    },
    {
      title: "Sprachlern-Dialog-Vorlage",
      content: `Schreiben Sie einen Konversationsdialog zwischen zwei Sprechern für Sprachlernende.
- Das Szenario ist [Essen bestellen auf einem belebten Straßenmarkt].
- Sprecher 1 ist [ein freundlicher lokaler Verkäufer, der seine besten Gerichte empfiehlt].
- Sprecher 2 ist [ein Reisender, der zum ersten Mal die lokale Küche probiert].
- Fügen Sie [natürliches Zögern, höfliche Ausdrücke und kulturellen Kontext] ein.
- Der Dialog sollte authentisch wirken und Lernenden bei [alltäglichen Konversationsphrasen] helfen.

Formatieren Sie jede Zeile als "Speaker 1:" oder "Speaker 2:" gefolgt von ihrem Dialog.`,
      mode: 'multi'
    }
  ]
};
